import { scenes } from "../scenes";
import { Scene, Choice, Dialog } from "../models";

const lieDialog = [
  new Dialog(
    "SONNY YANG: Actually friend, it was the Captain’s orders that us medical personnel be given priority service at the buffet table.",
    require("@/images/Masked_Sonny_Yang.png"),
    require("@/audio/Pandemic-95-Sonny-MP3.mp3")
  ),
  new Dialog(
    "[The OBNOXIOUS PASSENGER punches you in the face!]",
    require("@/images/Obnoxious_Passenger.png"),
    require("@/audio/loseitem.mp3")
  ),
];

const fightDialog = [
  new Dialog(
    "SONNY YANG: You don’t want to freak with me friend... Lest you wish to make a fool of yourself!",
    require("@/images/Masked_Sonny_Yang.png"),
    require("@/audio/Pandemic-94-Sonny-MP3.mp3")
  ),
  new Dialog(
    "...",
    require("@/images/Finger.png"),
    require("@/audio/flipoff.mp3")
  ),
  new Dialog(
    "[The OBNOXIOUS PASSENGER punches you in the face!]",
    require("@/images/Obnoxious_Passenger.png"),
    require("@/audio/loseitem.mp3")
  ),
];

const apologyDialog = [
  new Dialog(
    "SONNY YANG: My apologies friend, I guess I was a little impatient. Or, should I say… imp-ASIAN-t?",
    require("@/images/Masked_Sonny_Yang.png"),
    require("@/audio/Pandemic-96-Sonny-MP3.mp3")
  ), //TOOD: Split this audio
  new Dialog(
    "...",
    require("@/images/sonny.png"),
    require("@/audio/flipoff.mp3")
  ),
  new Dialog(
    "ANGRY PASSENGER: Oh my god, it’s one of them!!! He’ll give us YOGID - 19, abandon ship everyone!!!",
    require("@/images/Obnoxious_Passenger.png"),
    require("@/audio/Pandemic-96-Passenger-MP3.mp3")
  ),
  new Dialog(
    "[The passengers disembark the ship en masse!]",
    require("@/images/Ship_Deck_Empty.png"),
    require("@/audio/Found_Jingle.mp3")
  ),
  new Dialog(
    "SONNY YANG: Now that they’re out of the picture, I think I’ll take these for safekeeping.",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-96-Sonny2-MP3.mp3")
  ),
  new Dialog(
    "[Acquired 1 x SERVING TONGS]",
    require("@/images/Serving_Tongs.png"),
    require("@/audio/Found_Jingle.mp3")
  ),
];

export class BuffetTable extends Scene {
  async init() {
    this.image = require("@/images/Obnoxious_Passenger.png");
    this.title = "Quarantined Cruise Ship";
    this.description =
      "ANGRY PASSENGER: Oi! Back of the line pal! Some of us been waiting all day to get our hands on these chipolatas!";
    this.audio = require("@/audio/Pandemic-93-Passenger-MP3.mp3");
  }

  get options(): any[] {
    return [
      new Choice("Intimidate Him", async () => {
        await this.dialogRunner(fightDialog)
        await this.navigate(scenes.EmergencyRoom())
      }),
      new Choice("Apologise to Him ", async () => {
        await this.dialogRunner(apologyDialog)
        this.state.inventory.tongs.has = true;
        await this.navigate(scenes.Harbour());
      }),
      new Choice("Lie to Him", async () => {
        await this.dialogRunner(lieDialog)
        await this.navigate(scenes.EmergencyRoom())
      }),
    ];
  }
}

export default new BuffetTable();
